import {
  Component,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { DocumentClickHandler } from '../../shared/classes/document-click-handler';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { MatOption } from '@angular/material/core';


@Component({
    selector: 'rt-basic-select-autocomplete-input',
    templateUrl: './basic-select-autocomplete-input.component.html',
    styleUrls: ['./basic-select-autocomplete-input.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, NgClass, MatError, MatOption]
})
export class BasicSelectAutocompleteInputComponent implements OnInit, OnDestroy {
  @HostBinding('class.opened') opened = false;

  @Input() label = '';
  @Input() name: string;
  @Input() form: UntypedFormGroup;
  @Input() fields: object;
  @Input() errors: object;
  @Input() required: boolean;
  @Input() readonly: boolean;
  @Input() placeholder: string;

  @Output() selected = new EventEmitter<string>();

  subscription = new Subscription();

  innerValue = '';
  filterValue = '';

  isOptionsOpened = false;

  public isAlive = true;

  protected _options = [];

  @Input()
  set options(options) {
    this._options = options;
  }

  get options() {
    return this._options;
  }

  protected _disabled = false;

  @Input()
  set disabled(disabled) {
    this.setDisabled(disabled);
  }

  get disabled(): boolean {
    return this._disabled;
  }

  get filteredOptions() {
    if (this.filterValue) {
      const autocompleteOptions = this.options.filter(option => option.toLowerCase().indexOf(this.filterValue.toLowerCase()) !== -1);
      if (autocompleteOptions?.length > 0) {
        return autocompleteOptions;
      } else {
        this.toggleOptionsDropdown();
        return null;
      }
    }
    return this.options;
  }

  constructor(public _eref: ElementRef, protected cd: ChangeDetectorRef) {
    DocumentClickHandler.addHandler({
      component: this,
      handler: (e) => {
        if (!this._eref.nativeElement.contains(e.target) && this.opened) {
          this.opened = false;
          this.cd.detectChanges();
        }
      }
    });
  }

  ngOnInit() {
    const element = this.form.get(this.name);

    if (element) {
      this.subscription.add(
        this.form.get(this.name).valueChanges.subscribe(value => {
          this.setInnerValue(value);
        })
      );
    }
  }

  setInnerValue(value) {
    this.innerValue = value;
  }

  setDisabled(disabled) {
    this._disabled = disabled;
    if (!this.form || !this.form.controls || !this.form.get(this.name)) {
      return;
    }

    if (this.form && this.form.get(this.name).disabled !== disabled) {
      if (disabled) {
        this.form.get(this.name).disable();
      } else {
        this.form.get(this.name).enable();
      }
    }
  }

  selectOption(option) {
    this.setInnerValue(option);
    this.form.get(this.name).setValue(option);
    this.form.get(this.name).markAsDirty();

    this.toggleOptionsDropdown();
    this.opened = false;
    this.selected.emit(this.innerValue);
  }

  ngOnDestroy() {
    this.isAlive = false;
    this.subscription.unsubscribe();
    this.cd.detach();
  }

  toggleOptionsDropdown() {
    this.isOptionsOpened = !this.isOptionsOpened;
    this.cd.detectChanges();
  }

  filterOptions(event) {
    this.filterValue = event.target.value;
    this.isOptionsOpened = true;

    if (this.filterValue === '') {
      this.form.get(this.name).setValue(null);
      this.toggleOptionsDropdown();
      this.form.get(this.name).markAsDirty();
      this.form.get(this.name).markAsTouched();
      this.cd.detectChanges();
    } else {
      this.form.get(this.name).setValue(this.filterValue);
    }
  }
}
